import { Component, OnInit, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../../shared/services/user.service';
import { RestApiService } from '../../shared/services/restapi.service';
import { NotificationService } from '../../shared/services/notification.service';
import { UtilityService } from '../../shared/services/utility.service';

@Component({
  selector: 'app-acneincome',
  templateUrl: './acneincome.component.html',
  styleUrls: ['./acneincome.component.scss']
})
export class AcneincomeComponent implements OnInit, OnDestroy {
  @ViewChild('sizzleVideo') sizzleVideo?: ElementRef<HTMLVideoElement>;

  repName: string = '';
  repEmail: string = '';
  repPhone: string = '';
  webAlias: string = '';
  repCustomerId: any = 0;
  /** Poster / overlay thumbnail */
  sizzleThumbnailUrl = encodeURI('assets/newfunnel/Turn Acne Into An Income.png');
  /** Hosted acne funnel sizzle video */
  videoSrcUrl = 'assets/newfunnel/ACNEBIZ.mp4';
  /** Whether the user has clicked play (hides poster overlay) */
  videoPlaying = false;

  leadForm = {
    name: '',
    email: '',
    phone: ''
  };

  formSubmitted: boolean = false;
  isSubmitting: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private apiService: RestApiService,
    private notificationService: NotificationService,
    private utilityService: UtilityService
  ) {}

  onPlayClick(): void {
    this.videoPlaying = true;
    setTimeout(() => {
      const el = this.sizzleVideo?.nativeElement;
      if (el) {
        void el.play();
      }
    });
  }

  ngOnInit(): void {
    this.utilityService.showSimplifiedheader(true);

    // Extract the webAlias from the full browser URL path
    const fullPath = window.location.pathname;
    const pathSegments = fullPath.split('/').filter(segment => segment && !segment.includes('?'));

    // The webAlias should be the first segment if it exists and isn't 'acneincome'
    if (pathSegments.length > 0 && pathSegments[0] !== 'acneincome') {
      this.webAlias = pathSegments[0];
    }

    // Try to get rep info from user service enrollerInfo
    if (this.userService.userServiceModal?.enrollerInfo) {
      const enrollerInfo = this.userService.userServiceModal.enrollerInfo;
      this.repName = `${enrollerInfo.FirstName || ''} ${enrollerInfo.LastName || ''}`.trim();
      this.repCustomerId = enrollerInfo.CustomerId || 0;
      this.repEmail = enrollerInfo.EmailAddress || '';

      if (!this.repName && this.webAlias) {
        this.repName = this.webAlias;
      }
    } else if (this.webAlias) {
      this.repName = this.webAlias;
    }

    // If still no rep name, try to get it from localStorage
    if (!this.repName) {
      const userData = JSON.parse(localStorage.getItem('user') || '{}');
      if (userData.FirstName || userData.LastName) {
        this.repName = `${userData.FirstName || ''} ${userData.LastName || ''}`.trim();
      } else if (userData.WebAlias) {
        this.repName = userData.WebAlias;
      }
      if (userData.CustomerId) {
        this.repCustomerId = userData.CustomerId;
      }
      if (userData.Email || userData.EmailAddress) {
        this.repEmail = userData.Email || userData.EmailAddress;
      }
      if (userData.Phone || userData.PhoneNumber || userData.MobilePhone) {
        this.repPhone = userData.Phone || userData.PhoneNumber || userData.MobilePhone;
      }
    }

    // Final fallback
    if (!this.repName) {
      this.repName = 'Your Rep';
    }
  }

  async onSubmit(): Promise<void> {
    // Validate form
    if (!this.leadForm.name || !this.leadForm.email || !this.leadForm.phone) {
      this.notificationService.error('Error', 'Please fill in all required fields');
      return;
    }

    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(this.leadForm.email)) {
      this.notificationService.error('Error', 'Please enter a valid email address');
      return;
    }

    this.isSubmitting = true;

    const leadData = {
      name: this.leadForm.name,
      email: this.leadForm.email,
      phone: this.leadForm.phone,
      repCustomerId: this.repCustomerId,
      repName: this.repName,
      repEmail: this.repEmail,
      repPhone: this.repPhone,
      webAlias: this.webAlias,
      source: 'acneincome',
      siteOrigin: window.location.origin,
      submittedDate: new Date().toISOString()
    };

    // Hardcoded production API URL for FunStudios backend
    const API_BASE_URL = 'https://tangerine-fun-funstudios.onrender.com';

    try {
      // Save lead to database
      const saveResponse = await fetch(`${API_BASE_URL}/api/leads`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(leadData)
      });

      if (!saveResponse.ok) {
        throw new Error('Failed to save lead');
      }

      // Fire emails in the background
      fetch(`${API_BASE_URL}/api/send-emails`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ leadData })
      });

    } catch (error) {
      console.error('Lead submission error:', error);
      this.notificationService.error('Error', 'Failed to submit lead. Please try again.');
      this.isSubmitting = false;
      return;
    }

    this.isSubmitting = false;
    this.formSubmitted = true;
    this.notificationService.success('Success', 'Your information has been submitted successfully!');

    // Redirect to thefunstudio (Coming Soon) page after 1 second
    setTimeout(() => {
      this.router.navigate(['/thefunstudio']);
    }, 1000);
  }

  ngOnDestroy(): void {
    this.utilityService.showSimplifiedheader(false);
  }
}
